import ISimpleDateObject from '@legalosApi/types/ISimpleDateObject';

/**
 * Normalizes a Date-question value to an ISimpleDateObject.
 *
 * LegalOS answers Date questions with { day, month (0-based), year }. The same
 * value reaches the client in two other shapes: as the JSON string stored in
 * PersistentState (user values, e.g. '{"day":9,"month":8,"year":2026}', key
 * order not guaranteed) and as a plain object from the Apollo cache. Anything
 * else - or a combination that does not form a valid calendar date - yields
 * undefined instead of an Invalid Date, which date-fns would reject with
 * "Invalid time value" and take the whole app down with it.
 */
export function parseSimpleDate(value: unknown): ISimpleDateObject | undefined {
  let candidate: unknown = value;
  if (typeof value === 'string') {
    try {
      candidate = JSON.parse(value);
    } catch {
      return undefined;
    }
  }
  if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) return undefined;

  const { day, month, year } = candidate as Record<string, unknown>;
  if (typeof day !== 'number' || typeof month !== 'number' || typeof year !== 'number') return undefined;
  if (isNaN(new Date(year, month, day).getTime())) return undefined;

  return { day, month, year };
}
